export const colors = {
  8: '#000000', // Black
  260: '#808080', // Grey (for unknown)
  29: '#FFFFFF', // White
  118: '#C0C0C0', // Stainless Steel (Silver)
  4: '#FF0000', // Red
  119: '#C0C0C0', // Silver
  226: '#E5E4E2', // Platinum Silver
};
